<!--    
@author zhijie.huang
@date 2018/9/19
@version v1.1.0
@description 字典mixins组件

内置data对象：
dDictionary
dDictionaryGroup
dDictionaryApp

内置method对象：
// 根据code查字典
dGetDictionaryByCode

// 根据group查app
dGetAppByGroup

// 查group
dGetGroup

-->
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      dDictionary: state => state.dicModule.data,
      dDictionaryGroup: state => state.dicModule.group,
      dDictionaryApp: state => state.dicModule.app
    })
  },
  methods: {
    dGetDictionaryByCode (code, flag = false) {
      return this.$store.dispatch('getByCode', {
        code: code,
        flag: flag
      })
    },
    dGetAppByGroup (siteCode, group) {
      return this.$store.dispatch('getAppByGroup', {
        siteCode: siteCode,
        group: group
      })
    },
    dGetGroup (siteCode, siteChange) {
      return this.$store.dispatch('getGroup', {
        siteCode: siteCode,
        siteChange: siteChange
      })
    }
  }
}
</script>
